module.exports = __webpack_public_path__ + "b0ebf69a085c576d255dfcc66643c829.png";